import React from 'react';

const LogoSlider = () => {
  // Client logos from the public/logos directory
  const logos = [
    { id: 1, name: 'HomeShield Direct', src: '/logos/icon2.webp' },
    { id: 2, name: 'PerfectHome', src: '/logos/icon3.webp' },
    { id: 3, name: 'Carphone Warehouse', src: '/logos/icon5.webp' },
    { id: 4, name: 'A-Plan', src: '/logos/icon6.webp' },
    { id: 5, name: 'Vanquis', src: '/logos/icon7.webp' },
    { id: 6, name: 'McCarthy & Stone', src: '/logos/imgpsh_fullsize_anim.webp' },
  ];

  // Duplicate logos for seamless infinite scroll
  const duplicatedLogos = [...logos, ...logos];

  return (
    <section className="bg-white py-12 sm:py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Logo container with auto-sliding animation */}
        <div className="overflow-hidden">
          <div className="flex items-center logo-slide space-x-8 sm:space-x-12 md:space-x-16 lg:space-x-20">
            {duplicatedLogos.map((logo, index) => (
              <div
                key={`${logo.id}-${index}`}
                className="flex-shrink-0 flex items-center justify-center h-16 sm:h-20 md:h-24 min-w-[120px] sm:min-w-[150px] md:min-w-[180px]"
              >
                <img
                  src={logo.src}
                  alt={logo.name}
                  className={`max-h-full max-w-full object-contain opacity-90 transition-all duration-300 ${
                    logo.src === '/logos/icon6.webp' ? 'logo-aplan-large' : ''
                  }`}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogoSlider;